import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { SectionLayout } from '@/components/atoms/SectionLayout/SectionLayout';
import { MODAL_MEMBER_INVITE } from '@/components/organisms/Modals/ModalConductor';
import InvitationFieldset from '@/components/pages/Invitations/InvitationFieldset/InvitationFieldset';
import InvitationsEmpty from '@/components/pages/Invitations/InvitationsEmpty/InvitationsEmpty';
import InvitationSkeleton from '@/components/pages/Invitations/InvitationSkeleton/InvitationSkeleton';
import { Button } from '@/components/ui/button';
import { useInvitations } from '@/hooks/useInvitations';
import { pushModal } from '@/redux/modals/actions';

export const InvitationsSection = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { invitations, respondInvitation } = useInvitations();

  return (
    <SectionLayout title={t('pages.invitations_simple')}>
      <div className="flex flex-col gap-2">
        {!invitations && <InvitationSkeleton />}
        {invitations?.map((invitation) => (
          <InvitationFieldset
            key={invitation.invitation_code}
            invitation={invitation}
            respondInvitation={respondInvitation}
          />
        ))}
        <InvitationsEmpty />
        <Button
          variant="ghost"
          size="sm"
          className="self-start"
          onClick={() => dispatch(pushModal(MODAL_MEMBER_INVITE))}
        >
          {t('invitations.want_to_invite')}
        </Button>
      </div>
    </SectionLayout>
  );
};
